import Layout from './Layout';
import Sider from './Sider';

Layout.Sider = Sider;

export default Layout;
